<template>
  <div class="circle-bar-wrap" :class="{ star: star }">
    <h2>
      {{ value | numeral("0%") }}
      <div class="common-light-label">{{ label }}</div>
    </h2>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      width="120"
      height="120"
      viewBox="0 0 120 120"
    >
      <g transform="translate(10, 10)">
        <path
          :id="'motionPath' + _uid"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          stroke="rgba(178, 188, 197, .2)"
          stroke-width="8"
          d="M50,0A50,50,0,1,1,0,50,50,50,0,0,1,50,0Z"
        ></path>

        <path
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          :stroke="color"
          stroke-width="8"
          d="M50,0A50,50,0,1,1,0,50,50,50,0,0,1,50,0Z"
          stroke-linecap="round"
          :style="`stroke-dasharray: 315; stroke-dashoffset: ${pieFill};`"
        ></path>

        <template v-if="mark">
          <polygon
            :id="'triangle' + _uid"
            points="0,0 20,0 10,16"
            fill="#444"
            stroke="#f5f7fb"
            stroke-width="4"
            transform="translate(-10, -6)"
          ></polygon>

          <animateMotion
            :xlink:href="'#triangle' + _uid"
            begin="0s"
            :end="mark"
            dur="1s"
            fill="freeze"
            rotate="auto"
          >
            <mpath :xlink:href="'#motionPath' + _uid"></mpath>
          </animateMotion>
        </template>
      </g>
    </svg>
  </div>
</template>

<script>
export default {
  name: "RoePie",
  props: {
    value: {
      required: true
    },
    color: {
      type: String,
      required: true
    },
    mark: {
      type: Number,
      required: false
    },
    label: {
      type: Number,
      required: false
    },
    star: {
      type: Boolean,
      required: false,
      default() {
        return false;
      }
    }
  },
  computed: {
    pieFill() {
      return 315 * (1 - this.value);
    }
  }
};
</script>
